import api from '@api/apiServices';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { emailTemplateQueryOptions } from '@utils/queryOptions';
import EditTemplate from '@Views/Emails/templates/edit';

export const Route = createFileRoute('/emails/templates/$templateId')({
    component: EditTemplate,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailTemplateQueryOptions(opts.params.templateId),
        ),
    beforeLoad: data => {
        if (data.params.templateId === 'new') {
            return data.context.queryClient.fetchQuery({
                queryKey: ['newEmailTemplate', Math.random()],
                queryFn: () =>
                    api.emails.templates
                        .postForm({ title: 'New Email Template' })
                        .then(res => redirect({ to: `../${res.id}` })),
            });
        }
    },
});
